import {
  Component
} from '@angular/core';

import * as moment from 'moment';


export class NgxSchedulerMonthComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-scheduler-month',
  template: `
    
  `,
  styles: [`


  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
